/** Inbox → « Créer un ticket » (D-129): turns a WhatsApp / Messenger conversation into a support
 * request (the last messages of the customer become the request; the ticket opens). */

import { type SupportTicketCategoryEnum, useSupportTicketsFromConversationCreate } from "@agencyos/api-client";
import { Button, SelectField, TextField } from "@agencyos/ui-web";
import { type FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { CATEGORIES, useSupportPermissions } from "./shared";

export function CreateTicketFromConversation({ conversationId }: { conversationId: string }) {
  const { t } = useTranslation();
  const can = useSupportPermissions();
  const create = useSupportTicketsFromConversationCreate();
  const [open, setOpen] = useState(false);
  const [subject, setSubject] = useState("");
  const [category, setCategory] = useState<SupportTicketCategoryEnum>("other");
  if (!can("support.tickets.create")) return null;
  const created = create.data?.status === 201 ? create.data.data : undefined;
  if (created) {
    return (
      <p role="status">
        <Link to={`/support/tickets/${created.id}`}>{t("support.inbox.created", { number: created.number })}</Link>
      </p>
    );
  }
  if (!open) {
    return (
      <Button type="button" size="sm" variant="secondary" onClick={() => setOpen(true)}>
        {t("support.inbox.createTicket")}
      </Button>
    );
  }
  const onSubmit = (event: FormEvent) => {
    event.preventDefault();
    create.mutate({ data: { conversation: conversationId, subject: subject.trim(), category } });
  };
  return (
    <form className="row support-tools" onSubmit={onSubmit} aria-label={t("support.inbox.createTicket")}>
      <TextField label={t("support.inbox.subject")} value={subject} maxLength={200} onChange={(e) => setSubject(e.target.value)} />
      <SelectField
        label={t("support.inbox.category")}
        value={category}
        onChange={(e) => setCategory(e.target.value as SupportTicketCategoryEnum)}
        options={CATEGORIES.map((c) => ({ value: c, label: t(`support.category.${c}`) }))}
      />
      <Button type="submit" size="sm" disabled={!subject.trim() || create.isPending}>
        {t("support.inbox.create")}
      </Button>
    </form>
  );
}
